
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bestpostagemeters/terms-and-conditions",
      function () {
        return require("private-next-pages/bestpostagemeters/terms-and-conditions.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bestpostagemeters/terms-and-conditions"])
      });
    }
  